export default "__VITE_ASSET__BDQyXwal__"